import { Injectable } from "@angular/core";
import { WaldayuInfo } from './global'
import { Entry } from '../pages/shared/entry.model'
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Storage } from '@ionic/storage';

import * as _ from 'lodash';

@Injectable()
export class WaldayuService {
    public bookmarks = new BehaviorSubject<Entry[]>([]);
    categories: Object = {};
    constructor(public storage: Storage) {
        if (WaldayuInfo.allAudioEntries.length > 0) {
            // this.categories["audio"] = {};
            // this.categories["audio"]["audio"] = WaldayuInfo.allAudioEntries;
        }
        for (let key of WaldayuInfo.dataKeys) {
            this.categories[key] = WaldayuInfo.dataDict[key].data
        }
        let semantic_categories = _.uniq(WaldayuInfo.allEntries.map(entry=>entry.theme[0].toLowerCase())).sort()
        for (let cat of semantic_categories) {
            this.categories[cat] = WaldayuInfo.allEntries.filter(entry=>entry.theme[0] === cat)
        }
    }

    setBookmarks(val) {
        this.bookmarks.next(val)
        this.storage.set(WaldayuInfo.config.L1.name + WaldayuInfo.config.build, JSON.stringify(val));
    }

    toggleBookmark(entry) {
        let i = this.bookmarks.value.indexOf(entry)
        let bookmarks;
        if (i > -1) {
            bookmarks = this.bookmarks.value
            bookmarks.splice(i, 1)
        } else if (i < 0) {
            bookmarks = this.bookmarks.value.concat([entry])
        }
        this.setBookmarks(bookmarks)
    }

}


// WEBPACK FOOTER //
// ./src/app/waldayu.service.ts